import axios from 'axios'
import heartbeatService from '@/services/heartbeatService'

const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8001/api'

class AuthService {
  constructor() {
    this.token = localStorage.getItem('token')
    this.userId = localStorage.getItem('userId')

    // Axios interceptor a token automatikus hozzáadásához
    axios.interceptors.request.use(
      (config) => {
        if (this.token) {
          config.headers.Authorization = `Bearer ${this.token}`
          config.headers.UserId = `${this.userId}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    // Response interceptor a 401 hibák kezelésére
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          this.logout()
          window.location.href = '/login'
        }
        return Promise.reject(error)
      }
    )
  }

  async login(email, password) {
    try {
      const response = await axios.post(`${API_URL}/login`, {
        email,
        password
      })

      const { token, user } = response.data

      this.token = token
      this.userId = user.id

      localStorage.setItem('token', token)
      localStorage.setItem('userId', user.id)
      localStorage.setItem('user', JSON.stringify(user))

      console.log('Login successful:', JSON.stringify(user, null, 2))
      // Heartbeat service elindítása bejelentkezés után
      heartbeatService.start()

      return { success: true, user }
    } catch (error) {
      return {
        success: false,
        message: JSON.parse(error?.response?.data?.details || '')?.message || 'Bejelentkezési hiba'
      }
    }
  }

  async register(userData) {
    try {
      const response = await axios.post(`${API_URL}/register`, userData)

      // Az új response formátum kezelése
      if (response.data.success) {
        return {
          success: true,
          status: response.status,
          message: response.data.message,
          data: response.data.data
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Regisztrációs hiba'
        }
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Regisztrációs hiba'
      }
    }
  }

  async forgotPassword(email) {
    try {
      const response = await axios.post(`${API_URL}/password/forgot`, {
        email
      })

      return {
        success: true,
        message: response.data.message,
        data: response.data
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Hiba történt a jelszó visszaállítás kérésekor'
      }
    }
  }

  async validateResetToken(email, token, new_user = false) {
    try {
      const response = await axios.post(`${API_URL}/password/validate`, {
        email,
        token,
        new_user
      })

      return {
        success: true,
        valid: response.data.valid, 
        new_link: response.data.new_link || null
      }
    } catch (error) {
      return {
        success: false,
        valid: false,
        message: error.response?.data?.message || 'Hiba történt a token ellenőrzésekor'
      }
    }
  }

  async resetPassword(email, token, password, password_confirmation) {
    try {
      // request headers: accept JSON response
      const response = await axios.post(
        `${API_URL}/password/reset`,
        {
          email,
          token,
          password,
          password_confirmation
        },
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      )

      return {
        success: true,
        message: response.data.message
      }
    } catch (error) {
      const status = error.response?.status
      const errorText = status ? `Request failed with status: ${status}` : error.message || 'Request failed'
      const details = error.response?.data?.details ?? (error.response?.data ? JSON.stringify(error.response.data) : '')

      return {
        success: false,
        error: errorText,
        details
      }
    }
  }

  logout() {
    // Heartbeat service leállítása
    heartbeatService.stop()
    
    this.token = null
    this.userId = null
    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('user')
    sessionStorage.clear()
  }

  isAuthenticated() {
    return !!this.token
  }

  getUser() {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  }

  getToken() {
    return this.token
  }

  getUserId() {
    return this.userId
  }

  isTester() {
    const user = this.getUser()
    return user?.is_tester || false;
  }

  hasRole(role) {
    const user = this.getUser()
    return user?.roles?.includes(role) || false
  }
}

export default new AuthService()